// ---------------------------------------------------------------
// AR Danışmanlık — Runtime Configuration
// ---------------------------------------------------------------
// PHP admin paneli hazır olduğunda aşağıdaki URL'i güncelleyin.
//   Örnek: "https://ardanismanlik.com.tr/api/content.php"
//
// Boş bırakılırsa veya istek başarısız olursa React otomatik olarak
// /src/mock/mock.js içindeki varsayılan içeriğe düşer.
// ---------------------------------------------------------------

export const CONTENT_API_URL = "https://arddanismanlik.com/api/content.php";

// İsteğe bağlı: Contact form POST endpoint'i (PHP)
export const CONTACT_API_URL = "https://arddanismanlik.com/api/contact.php";

// İstek zaman aşımı (ms)
export const API_TIMEOUT_MS = 6000;
